"use client";

import { Trash2Icon } from "lucide-react";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../ui/dialog";
import { trpcApi } from "@lattice/frontend/lib/trpc/client";
import { useRouter } from "next/navigation";
import { toast } from "sonner";
import { E_Page } from "@lattice/frontend/lib/routes/routes";

export default function DeleteBlogButton({ blog_cuid }: { blog_cuid: string }) {
  const router = useRouter();
  const { data: is_admin } = trpcApi.users.get_is_admin.useQuery();
  const { mutate, isPending } = trpcApi.blog.delete_blog_by_cuid.useMutation({
    onSuccess: () => {
      toast.success("Blog has been deleted");
      router.replace(E_Page.Blog);
    },
    onError: (e) => {
      toast.error("Failed to delete blog: " + e.message);
    },
  });

  if (!is_admin) return null;

  return (
    <Dialog>
      <DialogTrigger>
        <Button variant="destructive">
          <Trash2Icon />
          Delete
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogDescription className="sr-only">
            Confirm Delete?
          </DialogDescription>
        </DialogHeader>
        Are you sure you want to delete this blog? This action is irreversible!
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose>
          <Button
            onClick={() => {
              mutate({ cuid: blog_cuid });
            }}
            loading={isPending}
          >
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
